import { render, staticRenderFns } from "./SubjectsTitles.vue?vue&type=template&id=72936176&scoped=true"
import script from "./SubjectsTitles.vue?vue&type=script&lang=js"
export * from "./SubjectsTitles.vue?vue&type=script&lang=js"
import style0 from "./SubjectsTitles.vue?vue&type=style&index=0&id=72936176&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72936176",
  null
  
)

export default component.exports